@if (messageInfo.listing) {
<gallery-listing-card class="lm-card" [listing]="messageInfo.listing" [canSelect]="false" [isShortCard]="true"
    [hideOpenRentals]="shouldHideOpenRentals" [companyConfiguration]="companyConfiguration"
    (listingDetailsClicked)="onMessageCardClicked()" (mediaViewerClicked)="onMediaViewerClicked($event)"
    (priceChangeClicked)="onMessageCardClicked()">

    <ng-template #bodyExtraFooter>

        <div class="lm-card-footer" (click)="$event.stopPropagation(); onMessageCardClicked()">

            <div class="lm-card-footer-block">

                <div class="lm-card-footer-icon-wrap">

                    <rpc-icon class="lm-card-footer-icon" [iconName]="'comments'">
                    </rpc-icon>

                </div>

                <div class="lm-card-footer-message">
                    {{ messageInfo.message.comment }}
                </div>

            </div>

            <div class="lm-card-footer-info">

                <div class="lm-card-footer-name" [title]="messageInfo.message.createName">
                    {{messageInfo.message.createName}}
                </div>

                <div class="lm-card-footer-date">
                    {{ messageInfo.message.dateCreated | date:dateConstants.Formats.AngularPipeShortDateSlash }},
                    {{ messageInfo.message.dateCreated | date:dateConstants.Formats.AngularPipeShortTime}}
                </div>

            </div>

        </div>

    </ng-template>

</gallery-listing-card>
}